<!-- eslint-disable max-len -->
<template>
  <div>
    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <!-- <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show();
                    showAdditionalInfo = true;">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div> -->

      <div
        slot="status"
        slot-scope="props">
        {{ props.row.status.toUpperCase() }}
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Detail Data Pelanggaran</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.nis.$error}">
            <label> NIS </label>
            <j-input
              v-model="$v.data_master.nis.$model"
              :disabled="true"
              placeholder="NIS"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nama_siswa.$error}">
            <label> NAMA SISWA </label>
            <j-input
              v-model="$v.data_master.nama_siswa.$model"
              :disabled="true"
              placeholder="NAMA SISWA"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.semester.$error}">
            <label> Semester </label>
            <j-single-select
              v-model="$v.data_master.semester.$model"
              :options="list_semester"
              :placeholder="'Select Semester'"
              :disabled="true"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.title.$error}">
            <label> Judul Pelanggaran </label>
            <j-single-select
              v-model="$v.data_master.title.$model"
              :options="list_pelanggaran"
              :placeholder="'Judul Pelanggaran'"
              :disabled="true"
              label="nama"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.attachment.$error}">
            <label> Attachment </label>
            <j-upload-file
              v-if="showAdditionalInfo"
              v-model="$v.data_master.attachment.$model"
              :accepted-file-type="['pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_master.attachment.$model"
              :name-default="fileNameDefault"
              :url-upload="url_upload"
              :disabled="true"
              @url="getUrl"/>
          </b-form-group>

          <!-- <b-form-group :class="{'error-input' : $v.data_master.attachment.$error}">
            <label> File </label><br>
            <j-singleupload
              v-model="$v.data_master.attachment.$model"
              :accepted-file-type="['pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_master.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
            <label>
              Please choose file with supported format file pdf, jpg, png, jpeg.
            </label>
          </b-form-group> -->

          <j-form-base
            v-if="showAdditionalInfo"
            ref="jFormUpdate"
            :data-fields="dataFields"
            :is-detail="true"
            :is-disabled="true"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <!-- <b-button
            v-if="data_master.status === 'draft' && !readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button> -->
        </b-col>
        <b-col md="9">
          <div class="float-to-right m__t--20">
            <!-- <b-button
              v-if="data_master.status === 'draft' && !readOnly"
              class="btn green m__r--5"
              @click="submitData">
              Submit
            </b-button>
            <b-button
              v-if="data_master.status === 'draft' && !readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button> -->
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jFormBase from '@/views/kurikulum/additional-info/jFormBase';
import jUploadFile from '@/components/upload-file/jUploadFile';

export default {
  // eslint-disable-next-line
  name: 'jPelanggaran',
  components: {
    jLoadingTable,
    jFormBase,
    jUploadFile,
  },
  mixins: [
    jPrivRoles,
  ],
  props: {
  },
  data() {
    return {
      data_master: {
        nis: '',
        nama_siswa: '',
        type: '',
        title: null,
        semester: null,
        category_id: '9',
        attachment: null,
        additional_info: [],
        tahunajaran: '',
        kode_kelas: '',
      },
      fileNameDefault: '',
      list_pelanggaran: [],

      token: (JSON.parse(localStorage.getItem('Token'))).value,
      list_semester: [
        { id: 'Ganjil', name: 'Ganjil' },
        { id: 'Genap', name: 'Genap' },
      ],
      dataFields: [],
      showAdditionalInfo: false,
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['id', 'title', 'nis', 'nama_siswa', 'tahunajaran', 'semester', 'status', 'total_point_pelanggaran'],
      options: {
        headings: {
          id: 'ID',
          title: 'TITLE',
          nis: 'NIS',
          nama_siswa: 'NAMA SISWA',
          tahunajaran: 'TAHUN AJARAN',
          semester: 'SEMESTER',
          status: 'STATUS',
          total_point_pelanggaran: 'TOTAL POIN',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            status: '',
            module_id: 5,
            category_id: 9,
            nis: data.nis,
            limit: data.limit,
            page: data.page,
            tahunajaran: data.tahunajaran,
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.getListDocument(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },
  },
  watch: {
  },
  created() {
    this.getAdditionalInfo(9).then((res) => {
      this.dataFields = res.data.data.map(el => ({
        id: el.id,
        name: el.field_name,
        type: el.type,
        placeholder: el.placeholder,
        field_key: el.field_key,
        is_delete: false,
        is_editable: false,
        is_mandatory: false,
      }));
    });

    this.getListPelanggaran().then((res) => {
      this.list_pelanggaran = res.data.data;
    });
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', ['getAdditionalInfo', 'createDocument', 'updateDocument', 'detailDocument', 'deleteDocument', 'submitDocument', 'getListPelanggaran']),

    getUrl(data) {
      this.data_master.attachment = data;
    },

    loading(val) {
      const a = val;
      a.nis = '';
      a.tahunajaran = '';

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.showAdditionalInfo = false;
      this.data_master = {
        nis: '',
        nama_siswa: '',
        type: '',
        title: null,
        semester: null,
        category_id: '9',
        attachment: null,
        additional_info: [],
        tahunajaran: '',
        kode_kelas: '',
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      const dataPelanggaran = this.list_pelanggaran.find(f => f.nama === param.row.title);
      const params = {
        id: param.row.id,
      };
      this.detailDocument(params).then((res) => {
        this.data_master = {
          id: param.row.id,
          nis: param.row.nis,
          nama_siswa: param.row.nama_siswa,
          type: '',
          semester: param.row.semester,
          title: dataPelanggaran ? dataPelanggaran.id : null,
          category_id: '9',
          attachment: param.row.attachment,
          additional_info: [],
          tahunajaran: '',
          kode_kelas: '',
          status: res.data.data.status,
        };
        this.dataFields = res.data.data.additional_info.map(el => ({
          id: el.id,
          name: el.field_name,
          type: el.type,
          placeholder: el.placeholder,
          field_key: el.field_key,
          value: el.value,
          is_delete: false,
          is_editable: false,
          is_mandatory: false,
        }));
        this.fileNameDefault = param.row.attachment_name || '-';
        this.showAdditionalInfo = true;
      });
    },
  },
  validations() {
    return {
      data_master: {
        nis: {},
        nama_siswa: {},
        semester: {},
        title: {},
        attachment: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/buku-saku/tab-component-report/jPelanggaran.vue